import React, { useEffect, useState, useMemo } from 'react';
import api from '../lib/axios';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../components/ui/dialog';
import { Badge } from '../components/ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../components/ui/alert-dialog';
import { HelpTooltip, TitleWithHelp } from '../components/ui/help-tooltip';
import { ViewToggle } from '../components/ui/view-toggle';
import AnexosManager from '../components/AnexosManager';
import AnexosErrorBoundary from '../components/AnexosErrorBoundary';
import MoedaSelect from '../components/compras/MoedaSelect';
import { formatCurrency as fmtMoeda, getCurrencyMeta } from '../lib/currencies';
import { PAISES } from '../lib/tradeConstants';
import { Switch } from '../components/ui/switch';
import { 
  Package, Plus, Search, Filter, Edit, Trash2, AlertTriangle, 
  ArrowUpCircle, ArrowDownCircle, RefreshCw, TrendingUp, TrendingDown,
  Warehouse, FileText, DollarSign, BarChart3, Loader2, ChevronRight,
  Building2, ShoppingCart, CheckCircle2, XCircle, Truck, Edit2, Check, X,
  Copy, Tag, FolderTree, Layers, Globe
} from 'lucide-react';
import { toast } from 'sonner';

const TIPOS_PRODUTO = [
  { value: 'materia_prima', label: 'Matéria-Prima' },
  { value: 'componente', label: 'Componente' },
  { value: 'equipamento', label: 'Equipamento' },
  { value: 'acessorio', label: 'Acessório' },
  { value: 'revenda', label: 'Revenda' }
];

const UNIDADES = [
  { value: 'UN', label: 'Unidade (UN)' },
  { value: 'KG', label: 'Quilograma (KG)' },
  { value: 'L', label: 'Litro (L)' },
  { value: 'M', label: 'Metro (M)' },
  { value: 'M2', label: 'Metro² (M²)' },
  { value: 'M3', label: 'Metro³ (M³)' },
  { value: 'CX', label: 'Caixa (CX)' },
  { value: 'PC', label: 'Peça (PC)' },
  { value: 'PAR', label: 'Par (PAR)' },
  { value: 'JG', label: 'Jogo (JG)' }
];

const Produtos = () => {
  const [produtos, setProdutos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [categoriasProduto, setCategoriasProduto] = useState([]);
  const [tiposProduto, setTiposProduto] = useState([]);
  const [locaisEstoque, setLocaisEstoque] = useState([]);
  const [fornecedores, setFornecedores] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [tiposMovimentacao, setTiposMovimentacao] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('lista');
  
  // Filtros
  const [searchTerm, setSearchTerm] = useState('');
  const [filtroCategoria, setFiltroCategoria] = useState('');
  const [filtroTipo, setFiltroTipo] = useState('');
  const [filtroEstoqueBaixo, setFiltroEstoqueBaixo] = useState(false);
  const [produtoViewMode, setProdutoViewMode] = useState('grid');
  
  // Dialog de produto
  const [showProdutoDialog, setShowProdutoDialog] = useState(false);
  const [editingProduto, setEditingProduto] = useState(null);
  const [savingProduto, setSavingProduto] = useState(false);
  const [produtoForm, setProdutoForm] = useState({
    sku: '',
    codigo_barras: '',
    nome: '',
    modelo: '',
    descricao: '',
    descricao_completa: '',
    categoria: '',
    subcategoria: '',
    tipos: ['materia_prima'],  // Array para múltiplos tipos
    impacta_preco_embarcacao: false,
    tipo_impacto: 'padrao',
    marca_id: '',
    marca_nome: '',
    procedencia: 'nacional',
    unidade: 'UN',
    estoque_minimo: 0,
    estoque_maximo: '',
    ponto_pedido: 0,
    preco_custo: 0,
    margem_percentual: 0,
    preco_venda: '',
    moeda: 'BRL',
    // Importação
    hs_code: '',
    pais_origem: '',
    necessita_li: false,
    necessita_licenca_exercito: false,
    fabricado_sob_encomenda: false,
    lead_time_fabricacao_dias: '',
    quantidade_volumes: '',
    volume_cbm: '',
    // Dimensões
    dimensoes: { comprimento_cm: 0, largura_cm: 0, altura_cm: 0 },
    volume_m3: 0,
    peso_bruto: 0,
    peso_liquido: 0,
    // Frete
    tipo_embalagem: '',
    classe_transporte: 'normal',
    localizacao_fisica_padrao: '',
    // Garantia
    garantia_meses: 0,
    garantia_observacoes: '',
    // Dados fiscais
    ncm: '',
    cest: '',
    origem: '0',
    cfop_entrada: '',
    cfop_saida: '',
    cst_icms: '',
    aliq_icms: 0,
    aliq_ipi: 0,
    aliq_pis: 0,
    aliq_cofins: 0,
    // Outros
    observacoes: '',
    tags: [],
    anexos: [],
    fornecedores: []
  });
  
  // Dialog de marca
  const [showMarcaDialog, setShowMarcaDialog] = useState(false);
  const [novaMarca, setNovaMarca] = useState({ nome: '', descricao: '', pais_origem: '', site: '' });
  const [savingMarca, setSavingMarca] = useState(false);
  
  // Dialog de categoria
  const [showCategoriaDialog, setShowCategoriaDialog] = useState(false);
  const [novaCategoria, setNovaCategoria] = useState({ nome: '', descricao: '' });
  const [savingCategoria, setSavingCategoria] = useState(false);
  
  // Dialog de tipo
  const [showTipoDialog, setShowTipoDialog] = useState(false);
  const [novoTipo, setNovoTipo] = useState({ nome: '', descricao: '' });
  const [savingTipo, setSavingTipo] = useState(false);
  
  // Estados para edição de marcas, categorias e tipos
  const [editingMarca, setEditingMarca] = useState(null);
  const [editingCategoria, setEditingCategoria] = useState(null);
  const [editingTipoItem, setEditingTipoItem] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState({ type: null, id: null, nome: '' });
  
  // Dialog de local de estoque
  const [showLocalDialog, setShowLocalDialog] = useState(false);
  const [novoLocal, setNovoLocal] = useState({ nome: '', tipo: 'deposito', endereco: '', responsavel: '' });
  const [savingLocal, setSavingLocal] = useState(false);
  
  // Estado para adicionar fornecedor ao produto
  const [showAddFornecedor, setShowAddFornecedor] = useState(false);
  const [novoFornecedor, setNovoFornecedor] = useState({
    fornecedor_id: '',
    fornecedor_nome: '',
    codigo_fornecedor: '',
    preco: '',
    prazo_entrega_dias: '',
    quantidade_minima: 1,
    is_principal: false
  });
  
  // Dialog de movimentação
  const [showMovDialog, setShowMovDialog] = useState(false);
  const [movForm, setMovForm] = useState({
    produto_id: '',
    tipo: 'entrada',
    quantidade: '',
    custo_unitario: '',
    local_id: '',
    motivo: 'compra',
    documento_ref: '',
    observacao: ''
  });
  const [savingMov, setSavingMov] = useState(false);
  
  // Delete
  const [deleteId, setDeleteId] = useState(null);
  
  // Dashboard
  const [dashboard, setDashboard] = useState(null);

  useEffect(() => {
    document.title = "Produtos & Estoque — NautilusOS";
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [produtosRes, categoriasRes, locaisRes, fornecedoresRes, dashboardRes, marcasRes, tiposMovRes, categoriasProdRes, tiposProdRes] = await Promise.all([
        api.get('/produtos'),
        api.get('/categorias-checklist'),
        api.get('/locais-estoque'),
        api.get('/fornecedores'),
        api.get('/estoque/dashboard'),
        api.get('/marcas'),
        api.get('/tipos-movimentacao'),
        api.get('/categorias-produto'),
        api.get('/tipos-produto')
      ]);
      
      setProdutos(produtosRes.data || []);
      setCategorias(categoriasRes.data || []);
      setLocaisEstoque(locaisRes.data || []);
      setFornecedores(fornecedoresRes.data || []);
      setDashboard(dashboardRes.data);
      setMarcas(marcasRes.data || []);
      setTiposMovimentacao(tiposMovRes.data || []);
      setCategoriasProduto(categoriasProdRes.data || []);
      setTiposProduto(tiposProdRes.data || []);
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
      toast.error('Erro ao carregar dados');
    } finally {
      setLoading(false);
    }
  };

  // Produtos filtrados
  const produtosFiltrados = useMemo(() => {
    return produtos.filter(p => {
      const matchSearch = !searchTerm || 
        p.nome?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        p.sku?.toLowerCase().includes(searchTerm.toLowerCase());
      const matchCategoria = !filtroCategoria || filtroCategoria === 'all' || p.categoria === filtroCategoria;
      const matchTipo = !filtroTipo || filtroTipo === 'all' || p.tipo === filtroTipo;
      const matchEstoqueBaixo = !filtroEstoqueBaixo || 
        (p.estoque_disponivel ?? (p.estoque_total || 0) - (p.estoque_reservado_total || 0)) <= (p.estoque_minimo || 0);
      
      return matchSearch && matchCategoria && matchTipo && matchEstoqueBaixo;
    });
  }, [produtos, searchTerm, filtroCategoria, filtroTipo, filtroEstoqueBaixo]);

  // Handlers
  const openNewProduto = () => {
    setEditingProduto(null);
    setProdutoForm({
      sku: '',
      codigo_barras: '',
      nome: '',
      modelo: '',
      descricao: '',
      descricao_completa: '',
      categoria: '',
      subcategoria: '',
      tipos: ['materia_prima'],
      impacta_preco_embarcacao: false,
      tipo_impacto: 'padrao',
      marca_id: '',
      marca_nome: '',
      unidade: 'UN',
      estoque_minimo: 0,
      estoque_maximo: '',
      ponto_pedido: 0,
      preco_custo: 0,
      margem_percentual: 0,
      preco_venda: '',
      moeda: 'BRL',
      hs_code: '',
      pais_origem: '',
      necessita_li: false,
      necessita_licenca_exercito: false,
      fabricado_sob_encomenda: false,
      lead_time_fabricacao_dias: '',
      quantidade_volumes: '',
      volume_cbm: '',
      dimensoes: { comprimento_cm: 0, largura_cm: 0, altura_cm: 0 },
      volume_m3: 0,
      peso_bruto: 0,
      peso_liquido: 0,
      tipo_embalagem: '',
      classe_transporte: 'normal',
      localizacao_fisica_padrao: '',
      garantia_meses: 0,
      garantia_observacoes: '',
      ncm: '',
      cest: '',
      origem: '0',
      cfop_entrada: '',
      cfop_saida: '',
      cst_icms: '',
      aliq_icms: 0,
      aliq_ipi: 0,
      aliq_pis: 0,
      aliq_cofins: 0,
      observacoes: '',
      tags: [],
      anexos: [],
      fornecedores: []
    });
    setShowProdutoDialog(true);
  };

  const openEditProduto = (produto) => {
    setEditingProduto(produto);
    // Compatibilidade: se vier 'tipo' (string), converter para 'tipos' (array)
    let tipos = produto.tipos || [];
    if (!tipos.length && produto.tipo) {
      tipos = [produto.tipo];
    }
    if (!tipos.length) {
      tipos = ['materia_prima'];
    }
    
    setProdutoForm({
      sku: produto.sku || '',
      codigo_barras: produto.codigo_barras || '',
      nome: produto.nome || '',
      modelo: produto.modelo || '',
      descricao: produto.descricao || '',
      descricao_completa: produto.descricao_completa || '',
      categoria: produto.categoria || '',
      subcategoria: produto.subcategoria || '',
      tipos: tipos,
      impacta_preco_embarcacao: produto.impacta_preco_embarcacao || false,
      tipo_impacto: produto.tipo_impacto || 'padrao',
      marca_id: produto.marca_id || '',
      marca_nome: produto.marca_nome || '',
      procedencia: produto.procedencia || 'nacional',
      unidade: produto.unidade || 'UN',
      estoque_minimo: produto.estoque_minimo || 0,
      estoque_maximo: produto.estoque_maximo || '',
      ponto_pedido: produto.ponto_pedido || 0,
      preco_custo: produto.preco_custo || 0,
      margem_percentual: produto.margem_percentual || 0,
      preco_venda: produto.preco_venda || '',
      moeda: produto.moeda || 'BRL',
      hs_code: produto.hs_code || '',
      pais_origem: produto.pais_origem || '',
      necessita_li: produto.necessita_li || false,
      necessita_licenca_exercito: produto.necessita_licenca_exercito || false,
      fabricado_sob_encomenda: produto.fabricado_sob_encomenda || false,
      lead_time_fabricacao_dias: produto.lead_time_fabricacao_dias ?? '',
      quantidade_volumes: produto.quantidade_volumes ?? '',
      volume_cbm: produto.volume_cbm ?? '',
      dimensoes: produto.dimensoes || { comprimento_cm: 0, largura_cm: 0, altura_cm: 0 },
      volume_m3: produto.volume_m3 || 0,
      peso_bruto: produto.peso_bruto || 0,
      peso_liquido: produto.peso_liquido || 0,
      tipo_embalagem: produto.tipo_embalagem || '',
      classe_transporte: produto.classe_transporte || 'normal',
      localizacao_fisica_padrao: produto.localizacao_fisica_padrao || '',
      garantia_meses: produto.garantia_meses || 0,
      garantia_observacoes: produto.garantia_observacoes || '',
      ncm: produto.ncm || '',
      cest: produto.cest || '',
      origem: produto.origem || '0',
      cfop_entrada: produto.cfop_entrada || '',
      cfop_saida: produto.cfop_saida || '',
      cst_icms: produto.cst_icms || '',
      aliq_icms: produto.aliq_icms || 0,
      aliq_ipi: produto.aliq_ipi || 0,
      aliq_pis: produto.aliq_pis || 0,
      aliq_cofins: produto.aliq_cofins || 0,
      observacoes: produto.observacoes || '',
      tags: produto.tags || [],
      anexos: produto.anexos || [],
      fornecedores: produto.fornecedores || []
    });
    setShowProdutoDialog(true);
  };

  // Função para duplicar produto
  const duplicarProduto = (produto) => {
    // NÃO definir editingProduto - queremos criar um NOVO produto
    setEditingProduto(null);
    
    // Compatibilidade: se vier 'tipo' (string), converter para 'tipos' (array)
    let tipos = produto.tipos || [];
    if (!tipos.length && produto.tipo) {
      tipos = [produto.tipo];
    }
    if (!tipos.length) {
      tipos = ['materia_prima'];
    }
    
    // Copiar todos os dados EXCETO id, sku, estoque
    setProdutoForm({
      sku: '', // SKU vazio para ser preenchido novo
      codigo_barras: '', // Código de barras vazio
      nome: `${produto.nome} (Cópia)`, // Nome com sufixo
      modelo: produto.modelo || '',
      descricao: produto.descricao || '',
      descricao_completa: produto.descricao_completa || '',
      categoria: produto.categoria || '',
      subcategoria: produto.subcategoria || '',
      tipos: tipos,
      impacta_preco_embarcacao: produto.impacta_preco_embarcacao || false,
      tipo_impacto: produto.tipo_impacto || 'padrao',
      marca_id: produto.marca_id || '',
      marca_nome: produto.marca_nome || '',
      procedencia: produto.procedencia || 'nacional',
      unidade: produto.unidade || 'UN',
      estoque_minimo: produto.estoque_minimo || 0,
      estoque_maximo: produto.estoque_maximo || '',
      ponto_pedido: produto.ponto_pedido || 0,
      preco_custo: produto.preco_custo || 0,
      margem_percentual: produto.margem_percentual || 0,
      preco_venda: produto.preco_venda || '',
      moeda: produto.moeda || 'BRL',
      hs_code: produto.hs_code || '',
      pais_origem: produto.pais_origem || '',
      necessita_li: produto.necessita_li || false,
      necessita_licenca_exercito: produto.necessita_licenca_exercito || false,
      fabricado_sob_encomenda: produto.fabricado_sob_encomenda || false,
      lead_time_fabricacao_dias: produto.lead_time_fabricacao_dias ?? '',
      quantidade_volumes: produto.quantidade_volumes ?? '',
      volume_cbm: produto.volume_cbm ?? '',
      dimensoes: produto.dimensoes || { comprimento_cm: 0, largura_cm: 0, altura_cm: 0 },
      volume_m3: produto.volume_m3 || 0,
      peso_bruto: produto.peso_bruto || 0,
      peso_liquido: produto.peso_liquido || 0,
      tipo_embalagem: produto.tipo_embalagem || '',
      classe_transporte: produto.classe_transporte || 'normal',
      localizacao_fisica_padrao: produto.localizacao_fisica_padrao || '',
      garantia_meses: produto.garantia_meses || 0,
      garantia_observacoes: produto.garantia_observacoes || '',
      ncm: produto.ncm || '',
      cest: produto.cest || '',
      origem: produto.origem || '0',
      cfop_entrada: produto.cfop_entrada || '',
      cfop_saida: produto.cfop_saida || '',
      cst_icms: produto.cst_icms || '',
      aliq_icms: produto.aliq_icms || 0,
      aliq_ipi: produto.aliq_ipi || 0,
      aliq_pis: produto.aliq_pis || 0,
      aliq_cofins: produto.aliq_cofins || 0,
      observacoes: produto.observacoes || '',
      tags: produto.tags || [],
      anexos: [], // Anexos vazios - não copiar arquivos
      fornecedores: produto.fornecedores || [] // Manter fornecedores
    });
    
    setShowProdutoDialog(true);
    toast.info('Produto duplicado! Edite os dados e salve como novo.');
  };

  const saveProduto = async () => {
    if (!produtoForm.nome.trim()) {
      toast.error('Nome do produto é obrigatório');
      return;
    }
    
    setSavingProduto(true);
    try {
      if (editingProduto) {
        await api.put(`/produtos/${editingProduto.id}`, produtoForm);
        toast.success('Produto atualizado!');
      } else {
        await api.post('/produtos', produtoForm);
        toast.success('Produto cadastrado!');
      }
      setShowProdutoDialog(false);
      fetchData();
    } catch (error) {
      console.error('Erro ao salvar produto:', error);
      toast.error('Erro ao salvar produto');
    } finally {
      setSavingProduto(false);
    }
  };

  // Funções para gerenciar marcas
  const saveMarca = async () => {
    if (!novaMarca.nome.trim()) {
      toast.error('Nome da marca é obrigatório');
      return;
    }
    setSavingMarca(true);
    try {
      const response = await api.post('/marcas', novaMarca);
      const marcaCriada = response.data;
      setMarcas([...marcas, marcaCriada]);
      setProdutoForm({
        ...produtoForm,
        marca_id: marcaCriada.id,
        marca_nome: marcaCriada.nome
      });
      setShowMarcaDialog(false);
      setNovaMarca({ nome: '', descricao: '', pais_origem: '', site: '' });
      toast.success('Marca cadastrada!');
    } catch (error) {
      console.error('Erro ao salvar marca:', error);
      toast.error('Erro ao salvar marca');
    } finally {
      setSavingMarca(false);
    }
  };

  const handleMarcaChange = (marcaId) => {
    const marca = marcas.find(m => m.id === marcaId);
    setProdutoForm({
      ...produtoForm,
      marca_id: marcaId || '',
      marca_nome: marca?.nome || ''
    });
  };

  // Funções para salvar nova categoria
  const saveCategoria = async () => {
    if (!novaCategoria.nome.trim()) {
      toast.error('Nome da categoria é obrigatório');
      return;
    }
    setSavingCategoria(true);
    try {
      const response = await api.post('/categorias-produto', novaCategoria);
      const categoriaCriada = response.data;
      setCategoriasProduto([...categoriasProduto, categoriaCriada]);
      setProdutoForm({ ...produtoForm, categoria: categoriaCriada.nome });
      setShowCategoriaDialog(false);
      setNovaCategoria({ nome: '', descricao: '' });
      toast.success('Categoria cadastrada!');
    } catch (error) {
      console.error('Erro ao salvar categoria:', error);
      toast.error(error.response?.data?.detail || 'Erro ao salvar categoria');
    } finally {
      setSavingCategoria(false);
    }
  };

  // Funções para salvar novo tipo
  const saveTipo = async () => {
    if (!novoTipo.nome.trim()) {
      toast.error('Nome do tipo é obrigatório');
      return;
    }
    setSavingTipo(true);
    try {
      const response = await api.post('/tipos-produto', novoTipo);
      const tipoCriado = response.data;
      setTiposProduto([...tiposProduto, tipoCriado]);
      setProdutoForm({ ...produtoForm, tipo: tipoCriado.value });
      setShowTipoDialog(false);
      setNovoTipo({ nome: '', descricao: '' });
      toast.success('Tipo cadastrado!');
    } catch (error) {
      console.error('Erro ao salvar tipo:', error);
      toast.error(error.response?.data?.detail || 'Erro ao salvar tipo');
    } finally {
      setSavingTipo(false);
    }
  };

  // Funções para editar e deletar marcas
  const updateMarca = async (marca) => {
    try {
      await api.put(`/marcas/${marca.id}`, marca);
      setMarcas(marcas.map(m => m.id === marca.id ? marca : m));
      setEditingMarca(null);
      toast.success('Marca atualizada!');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao atualizar marca');
    }
  };

  const deleteMarca = async (id) => {
    try {
      await api.delete(`/marcas/${id}`);
      setMarcas(marcas.filter(m => m.id !== id));
      setDeleteConfirm({ type: null, id: null, nome: '' });
      toast.success('Marca removida!');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao remover marca');
    }
  };

  // Funções para editar e deletar categorias
  const updateCategoria = async (categoria) => {
    try {
      await api.put(`/categorias-produto/${categoria.id}`, categoria);
      setCategoriasProduto(categoriasProduto.map(c => c.id === categoria.id ? categoria : c));
      setEditingCategoria(null);
      toast.success('Categoria atualizada!');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao atualizar categoria');
    }
  };

  const deleteCategoria = async (id) => {
    try {
      await api.delete(`/categorias-produto/${id}`);
      setCategoriasProduto(categoriasProduto.filter(c => c.id !== id));
      setDeleteConfirm({ type: null, id: null, nome: '' });
      toast.success('Categoria removida!');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao remover categoria');
    }
  };

  // Funções para editar e deletar tipos de produto
  const updateTipoProduto = async (tipo) => {
    try {
      await api.put(`/tipos-produto/${tipo.id}`, tipo);
      setTiposProduto(tiposProduto.map(t => t.id === tipo.id ? tipo : t));
      setEditingTipoItem(null);
      toast.success('Tipo atualizado!');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao atualizar tipo');
    }
  };

  const deleteTipoProduto = async (id) => {
    try {
      await api.delete(`/tipos-produto/${id}`);
      setTiposProduto(tiposProduto.filter(t => t.id !== id));
      setDeleteConfirm({ type: null, id: null, nome: '' });
      toast.success('Tipo removido!');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao remover tipo');
    }
  };

  // Funções para salvar novo local de estoque
  const saveLocal = async () => {
    if (!novoLocal.nome.trim()) {
      toast.error('Nome do local é obrigatório');
      return;
    }
    setSavingLocal(true);
    try {
      const response = await api.post('/locais-estoque', novoLocal);
      const localCriado = response.data;
      setLocaisEstoque([...locaisEstoque, localCriado]);
      setShowLocalDialog(false);
      setNovoLocal({ nome: '', tipo: 'deposito', endereco: '', responsavel: '' });
      toast.success('Local de estoque cadastrado!');
    } catch (error) {
      console.error('Erro ao salvar local:', error);
      toast.error(error.response?.data?.detail || 'Erro ao salvar local');
    } finally {
      setSavingLocal(false);
    }
  };

  // Funções de cálculo de margem/preço
  const calcularPrecoVenda = (custoVal, margemVal) => {
    if (custoVal > 0 && margemVal > 0) {
      return (custoVal * (1 + margemVal / 100)).toFixed(2);
    }
    return '';
  };

  const calcularMargem = (custoVal, precoVal) => {
    if (custoVal > 0 && precoVal > 0) {
      return (((precoVal - custoVal) / custoVal) * 100).toFixed(2);
    }
    return 0;
  };

  const handlePrecoCustoChange = (valor) => {
    const custo = parseFloat(valor) || 0;
    const novoPreco = calcularPrecoVenda(custo, produtoForm.margem_percentual);
    setProdutoForm({
      ...produtoForm,
      preco_custo: custo,
      preco_venda: novoPreco
    });
  };

  const handleMargemChange = (valor) => {
    const margem = parseFloat(valor) || 0;
    const novoPreco = calcularPrecoVenda(produtoForm.preco_custo, margem);
    setProdutoForm({
      ...produtoForm,
      margem_percentual: margem,
      preco_venda: novoPreco
    });
  };

  const handlePrecoVendaChange = (valor) => {
    const preco = parseFloat(valor) || 0;
    const novaMargem = calcularMargem(produtoForm.preco_custo, preco);
    setProdutoForm({
      ...produtoForm,
      preco_venda: valor,
      margem_percentual: parseFloat(novaMargem) || 0
    });
  };

  // Funções para gerenciar fornecedores do produto
  const addFornecedorAoProduto = () => {
    if (!novoFornecedor.fornecedor_id) {
      toast.error('Selecione um fornecedor');
      return;
    }
    
    // Verificar se já existe
    if (produtoForm.fornecedores.some(f => f.fornecedor_id === novoFornecedor.fornecedor_id)) {
      toast.error('Este fornecedor já está vinculado');
      return;
    }
    
    const fornecedorSelecionado = fornecedores.find(f => f.id === novoFornecedor.fornecedor_id);
    
    const novoVinculo = {
      fornecedor_id: novoFornecedor.fornecedor_id,
      fornecedor_nome: fornecedorSelecionado?.nome_fantasia || fornecedorSelecionado?.razao_social || '',
      codigo_fornecedor: novoFornecedor.codigo_fornecedor,
      preco: parseFloat(novoFornecedor.preco) || 0,
      prazo_entrega_dias: parseInt(novoFornecedor.prazo_entrega_dias) || 0,
      quantidade_minima: parseFloat(novoFornecedor.quantidade_minima) || 1,
      is_principal: novoFornecedor.is_principal || produtoForm.fornecedores.length === 0
    };
    
    // Se marcou como principal, desmarcar os outros
    let fornecedoresAtualizados = [...produtoForm.fornecedores];
    if (novoVinculo.is_principal) {
      fornecedoresAtualizados = fornecedoresAtualizados.map(f => ({...f, is_principal: false}));
    }
    
    setProdutoForm({
      ...produtoForm,
      fornecedores: [...fornecedoresAtualizados, novoVinculo]
    });
    
    setNovoFornecedor({
      fornecedor_id: '',
      fornecedor_nome: '',
      codigo_fornecedor: '',
      preco: '',
      prazo_entrega_dias: '',
      quantidade_minima: 1,
      is_principal: false
    });
    setShowAddFornecedor(false);
    toast.success('Fornecedor vinculado!');
  };

  const removeFornecedorDoProduto = (fornecedorId) => {
    setProdutoForm({
      ...produtoForm,
      fornecedores: produtoForm.fornecedores.filter(f => f.fornecedor_id !== fornecedorId)
    });
  };

  const toggleFornecedorPrincipal = (fornecedorId) => {
    setProdutoForm({
      ...produtoForm,
      fornecedores: produtoForm.fornecedores.map(f => ({
        ...f,
        is_principal: f.fornecedor_id === fornecedorId
      }))
    });
  };

  const deleteProduto = async () => {
    if (!deleteId) return;
    
    try {
      await api.delete(`/produtos/${deleteId}`);
      toast.success('Produto desativado!');
      setDeleteId(null);
      fetchData();
    } catch (error) {
      toast.error('Erro ao desativar produto');
    }
  };

  const openMovimentacao = (produto, tipo = 'entrada') => {
    setMovForm({
      produto_id: produto.id,
      tipo: tipo,
      quantidade: '',
      custo_unitario: tipo === 'entrada' ? '' : produto.custo_medio?.toString() || '',
      local_id: locaisEstoque[0]?.id || '',
      motivo: tipo === 'entrada' ? 'compra' : 'consumo_projeto',
      documento_ref: '',
      observacao: ''
    });
    setShowMovDialog(true);
  };

  const saveMovimentacao = async () => {
    if (!movForm.quantidade || parseFloat(movForm.quantidade) <= 0) {
      toast.error('Quantidade deve ser maior que zero');
      return;
    }
    if (!movForm.local_id) {
      toast.error('Selecione um local de estoque');
      return;
    }
    
    setSavingMov(true);
    try {
      await api.post('/movimentacoes-estoque', {
        ...movForm,
        quantidade: parseFloat(movForm.quantidade),
        custo_unitario: movForm.custo_unitario ? parseFloat(movForm.custo_unitario) : null
      });
      toast.success('Movimentação registrada!');
      setShowMovDialog(false);
      fetchData();
    } catch (error) {
      console.error('Erro na movimentação:', error);
      toast.error(error.response?.data?.detail || 'Erro ao registrar movimentação');
    } finally {
      setSavingMov(false);
    }
  };

  const formatCurrency = (value, moeda = 'BRL') => fmtMoeda(value, moeda);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader2 className="h-12 w-12 animate-spin text-blue-600" />
      </div>
    );
  }

  return (
    <div className="p-6 space-y-6" data-testid="produtos-page">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <TitleWithHelp
            title="Produtos & Estoque"
            description="Gerencie o cadastro completo de produtos, controle estoque por local, registre entradas e saídas, e acompanhe alertas de estoque baixo. Use a barra de ações para criar novos itens rapidamente."
            connections={["Fornecedores", "Projetos", "Produção", "Pedidos de Compra"]}
          >
            <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
              <Package className="h-6 w-6 text-blue-600" />
              Produtos & Estoque
            </h1>
          </TitleWithHelp>
          <p className="text-gray-500 mt-1">
            {produtos.length} produtos cadastrados • {locaisEstoque.length} locais de estoque
          </p>
        </div>
      </div>

      {/* Dashboard KPIs */}
      {dashboard && (
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <Card className="bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200">
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-blue-600 font-medium">Total Produtos</p>
                  <p className="text-2xl font-bold text-blue-900">{dashboard.total_produtos}</p>
                </div>
                <Package className="h-10 w-10 text-blue-500 opacity-50" />
              </div>
            </CardContent>
          </Card>
          
          <Card className="bg-gradient-to-br from-green-50 to-green-100 border-green-200">
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div className="min-w-0">
                  <p className="text-sm text-green-600 font-medium">Valor em Estoque</p>
                  {(() => {
                    const pm = dashboard.valor_estoque_por_moeda || {};
                    const codes = Object.keys(pm);
                    if (codes.length <= 1) {
                      const code = codes[0] || 'BRL';
                      return <p className="text-2xl font-bold text-green-900" data-testid="valor-estoque-total">{formatCurrency(pm[code] ?? dashboard.total_valor_estoque, code)}</p>;
                    }
                    return (
                      <div className="space-y-0.5" data-testid="valor-estoque-por-moeda">
                        {codes.sort().map(code => (
                          <p key={code} className="text-lg font-bold text-green-900 leading-tight" data-testid={`valor-estoque-${code}`}>
                            {formatCurrency(pm[code], code)}
                          </p>
                        ))}
                      </div>
                    );
                  })()}
                </div>
                <DollarSign className="h-10 w-10 text-green-500 opacity-50 shrink-0" />
              </div>
            </CardContent>
          </Card>
          
          <Card className={`bg-gradient-to-br ${dashboard.produtos_estoque_baixo > 0 ? 'from-amber-50 to-amber-100 border-amber-200' : 'from-gray-50 to-gray-100 border-gray-200'}`}>
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className={`text-sm font-medium ${dashboard.produtos_estoque_baixo > 0 ? 'text-amber-600' : 'text-gray-600'}`}>Estoque Baixo</p>
                  <p className={`text-2xl font-bold ${dashboard.produtos_estoque_baixo > 0 ? 'text-amber-900' : 'text-gray-900'}`}>{dashboard.produtos_estoque_baixo}</p>
                </div>
                <AlertTriangle className={`h-10 w-10 opacity-50 ${dashboard.produtos_estoque_baixo > 0 ? 'text-amber-500' : 'text-gray-400'}`} />
              </div>
            </CardContent>
          </Card>
          
          <Card className={`bg-gradient-to-br ${dashboard.produtos_sem_estoque > 0 ? 'from-red-50 to-red-100 border-red-200' : 'from-gray-50 to-gray-100 border-gray-200'}`}>
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className={`text-sm font-medium ${dashboard.produtos_sem_estoque > 0 ? 'text-red-600' : 'text-gray-600'}`}>Sem Estoque</p>
                  <p className={`text-2xl font-bold ${dashboard.produtos_sem_estoque > 0 ? 'text-red-900' : 'text-gray-900'}`}>{dashboard.produtos_sem_estoque}</p>
                </div>
                <XCircle className={`h-10 w-10 opacity-50 ${dashboard.produtos_sem_estoque > 0 ? 'text-red-500' : 'text-gray-400'}`} />
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      {/* Barra de Ações - Cadastros Rápidos */}
      <div className="flex flex-wrap gap-2 mb-4">
        <Button onClick={openNewProduto} data-testid="btn-novo-produto">
          <Plus className="h-4 w-4 mr-2" />
          Novo Produto
        </Button>
        <Button variant="outline" onClick={() => setShowLocalDialog(true)}>
          <Warehouse className="h-4 w-4 mr-2" />
          Novo Local de Estoque
        </Button>
        <Button variant="outline" onClick={() => setShowMarcaDialog(true)}>
          <Plus className="h-4 w-4 mr-2" />
          Nova Marca
        </Button>
        <Button variant="outline" onClick={() => setShowCategoriaDialog(true)}>
          <Plus className="h-4 w-4 mr-2" />
          Nova Categoria
        </Button>
        <Button variant="outline" onClick={() => setShowTipoDialog(true)}>
          <Plus className="h-4 w-4 mr-2" />
          Novo Tipo de Produto
        </Button>
      </div>

      {/* Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList>
          <TabsTrigger value="lista">
            <Package className="h-4 w-4 mr-2" />
            Lista de Produtos
          </TabsTrigger>
          <TabsTrigger value="locais">
            <Warehouse className="h-4 w-4 mr-2" />
            Locais de Estoque
          </TabsTrigger>
          <TabsTrigger value="marcas">
            <Tag className="h-4 w-4 mr-2" />
            Marcas
          </TabsTrigger>
          <TabsTrigger value="categorias">
            <FolderTree className="h-4 w-4 mr-2" />
            Categorias
          </TabsTrigger>
          <TabsTrigger value="tipos">
            <Layers className="h-4 w-4 mr-2" />
            Tipos
          </TabsTrigger>
        </TabsList>

        <TabsContent value="lista" className="mt-4">
          {/* Filtros */}
          <Card className="mb-4">
            <CardContent className="p-4">
              <div className="flex flex-wrap gap-4 items-end">
                <div className="flex-1 min-w-[200px]">
                  <Label className="text-sm text-gray-600">Buscar</Label>
                  <div className="relative">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                    <Input
                      placeholder="Nome ou SKU..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="pl-10"
                    />
                  </div>
                </div>
                
                <div className="w-[180px]">
                  <Label className="text-sm text-gray-600">Categoria</Label>
                  <Select value={filtroCategoria} onValueChange={setFiltroCategoria}>
                    <SelectTrigger>
                      <SelectValue placeholder="Todas" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="all">Todas</SelectItem>
                      {categoriasProduto.map(cat => (
                        <SelectItem key={cat.id} value={cat.nome}>{cat.nome}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                
                <div className="w-[180px]">
                  <Label className="text-sm text-gray-600">Tipo</Label>
                  <Select value={filtroTipo} onValueChange={setFiltroTipo}>
                    <SelectTrigger>
                      <SelectValue placeholder="Todos" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="all">Todos</SelectItem>
                      {TIPOS_PRODUTO.map(tipo => (
                        <SelectItem key={tipo.value} value={tipo.value}>{tipo.label}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                
                <Button
                  variant={filtroEstoqueBaixo ? "default" : "outline"}
                  onClick={() => setFiltroEstoqueBaixo(!filtroEstoqueBaixo)}
                  className={filtroEstoqueBaixo ? "bg-amber-500 hover:bg-amber-600" : ""}
                >
                  <AlertTriangle className="h-4 w-4 mr-2" />
                  Estoque Baixo
                </Button>
                
                <ViewToggle viewMode={produtoViewMode} setViewMode={setProdutoViewMode} />
              </div>
            </CardContent>
          </Card>

          {/* Lista de Produtos */}
          {produtosFiltrados.length === 0 ? (
            <Card>
              <CardContent className="p-8 text-center">
                <Package className="h-12 w-12 mx-auto text-gray-300 mb-3" />
                <p className="text-gray-500">Nenhum produto encontrado</p>
                <Button onClick={openNewProduto} className="mt-4">
                  <Plus className="h-4 w-4 mr-2" />
                  Cadastrar Produto
                </Button>
              </CardContent>
            </Card>
          ) : produtoViewMode === 'list' ? (
            <Card data-testid="produtos-list-view">
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b bg-gray-50/80">
                      <th className="text-left p-3 font-medium text-gray-600">Produto</th>
                      <th className="text-left p-3 font-medium text-gray-600">SKU</th>
                      <th className="text-left p-3 font-medium text-gray-600">Categoria</th>
                      <th className="text-left p-3 font-medium text-gray-600">Tipo</th>
                      <th className="text-right p-3 font-medium text-gray-600">Disponível</th>
                      <th className="text-right p-3 font-medium text-gray-600">Custo Médio</th>
                      <th className="text-right p-3 font-medium text-gray-600">Valor Total</th>
                      <th className="text-right p-3 font-medium text-gray-600">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {produtosFiltrados.map(produto => {
                      const estoqueTotal = produto.estoque_total || 0;
                      const estoqueReservado = produto.estoque_reservado_total || 0;
                      const estoqueDisponivel = produto.estoque_disponivel ?? (estoqueTotal - estoqueReservado);
                      const estoqueBaixo = estoqueDisponivel <= (produto.estoque_minimo || 0) && estoqueDisponivel > 0;
                      const semEstoque = estoqueDisponivel === 0;
                      
                      return (
                        <tr 
                          key={produto.id} 
                          className={`border-b hover:bg-blue-50/40 transition-colors group ${semEstoque ? 'bg-red-50/30' : estoqueBaixo ? 'bg-amber-50/30' : ''}`}
                          data-testid={`produto-row-${produto.id}`}
                        >
                          <td className="p-3">
                            <div className="flex items-center gap-2">
                              <Package className="h-4 w-4 text-blue-600 flex-shrink-0" />
                              <span className="font-medium text-gray-900">{produto.nome}</span>
                            </div>
                          </td>
                          <td className="p-3"><Badge variant="outline" className="text-xs">{produto.sku}</Badge></td>
                          <td className="p-3 text-gray-600">{produto.categoria || '—'}</td>
                          <td className="p-3 text-gray-600">{TIPOS_PRODUTO.find(t => t.value === produto.tipo)?.label || produto.tipo || '—'}</td>
                          <td className="p-3 text-right">
                            <span className={`font-medium ${semEstoque ? 'text-red-600' : estoqueBaixo ? 'text-amber-600' : 'text-gray-900'}`}>
                              {estoqueDisponivel} {produto.unidade}
                            </span>
                          </td>
                          <td className="p-3 text-right text-gray-700">{formatCurrency(produto.custo_medio, produto.moeda)}</td>
                          <td className="p-3 text-right font-medium text-green-600">{formatCurrency(estoqueDisponivel * (produto.custo_medio || 0), produto.moeda)}</td>
                          <td className="p-3 text-right">
                            <div className="flex items-center justify-end gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                              <Button size="sm" variant="outline" className="h-7 w-7 p-0 text-green-600 border-green-200" onClick={() => openMovimentacao(produto, 'entrada')} title="Entrada">
                                <ArrowDownCircle className="h-3.5 w-3.5" />
                              </Button>
                              <Button size="sm" variant="outline" className="h-7 w-7 p-0 text-red-600 border-red-200" onClick={() => openMovimentacao(produto, 'saida')} title="Saída" disabled={semEstoque}>
                                <ArrowUpCircle className="h-3.5 w-3.5" />
                              </Button>
                              <Button size="sm" variant="ghost" className="h-7 w-7 p-0" onClick={() => openEditProduto(produto)} title="Editar">
                                <Edit className="h-3.5 w-3.5" />
                              </Button>
                              <Button size="sm" variant="ghost" className="h-7 w-7 p-0 text-red-500" onClick={() => setDeleteId(produto.id)} title="Excluir">
                                <Trash2 className="h-3.5 w-3.5" />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </Card>
          ) : (
          <div className="grid gap-3">
            {produtosFiltrados.map(produto => {
                const estoqueTotal = produto.estoque_total || 0;
                const estoqueReservado = produto.estoque_reservado_total || 0;
                const estoqueDisponivel = produto.estoque_disponivel ?? (estoqueTotal - estoqueReservado);
                const estoqueBaixo = estoqueDisponivel <= (produto.estoque_minimo || 0) && estoqueDisponivel > 0;
                const semEstoque = estoqueDisponivel === 0;
                const temReserva = estoqueReservado > 0;
                
                return (
                  <Card 
                    key={produto.id} 
                    className={`hover:shadow-md transition-shadow ${semEstoque ? 'border-red-200 bg-red-50/30' : estoqueBaixo ? 'border-amber-200 bg-amber-50/30' : ''}`}
                  >
                    <CardContent className="p-4">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4 flex-1">
                          <div className="w-12 h-12 rounded-lg bg-blue-100 flex items-center justify-center">
                            <Package className="h-6 w-6 text-blue-600" />
                          </div>
                          
                          <div className="flex-1">
                            <div className="flex items-center gap-2">
                              <span className="font-semibold text-gray-900">{produto.nome}</span>
                              <Badge variant="outline" className="text-xs">{produto.sku}</Badge>
                              {produto.tipo && (
                                <Badge className="text-xs bg-gray-100 text-gray-600">
                                  {TIPOS_PRODUTO.find(t => t.value === produto.tipo)?.label || produto.tipo}
                                </Badge>
                              )}
                              {temReserva && (
                                <Badge className="text-xs bg-orange-100 text-orange-700">
                                  {estoqueReservado} reservado
                                </Badge>
                              )}
                            </div>
                            <div className="flex items-center gap-4 text-sm text-gray-500 mt-1">
                              {produto.categoria && <span>{produto.categoria}</span>}
                              <span>•</span>
                              <span>{produto.unidade}</span>
                              {produto.ncm && (
                                <>
                                  <span>•</span>
                                  <span>NCM: {produto.ncm}</span>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        
                        <div className="flex items-center gap-6">
                          {/* Estoque */}
                          <div className="text-center">
                            <p className="text-xs text-gray-500 uppercase">Disponível</p>
                            <p className={`text-lg font-bold ${semEstoque ? 'text-red-600' : estoqueBaixo ? 'text-amber-600' : 'text-gray-900'}`}>
                              {estoqueDisponivel}
                              <span className="text-xs font-normal text-gray-500 ml-1">{produto.unidade}</span>
                            </p>
                            {estoqueBaixo && !semEstoque && (
                              <p className="text-xs text-amber-600">Mín: {produto.estoque_minimo}</p>
                            )}
                          </div>
                          
                          {/* Custo Médio */}
                          <div className="text-center">
                            <p className="text-xs text-gray-500 uppercase">Custo Médio</p>
                            <p className="text-lg font-bold text-gray-900">
                              {formatCurrency(produto.custo_medio, produto.moeda)}
                            </p>
                          </div>
                          
                          {/* Valor Total */}
                          <div className="text-center">
                            <p className="text-xs text-gray-500 uppercase">Valor Total</p>
                            <p className="text-lg font-bold text-green-600">
                              {formatCurrency(estoqueDisponivel * (produto.custo_medio || 0), produto.moeda)}
                            </p>
                          </div>
                          
                          {/* Ações */}
                          <div className="flex items-center gap-2">
                            <Button
                              size="sm"
                              variant="outline"
                              className="text-green-600 border-green-200 hover:bg-green-50"
                              onClick={() => openMovimentacao(produto, 'entrada')}
                            >
                              <ArrowDownCircle className="h-4 w-4" />
                            </Button>
                            <Button
                              size="sm"
                              variant="outline"
                              className="text-red-600 border-red-200 hover:bg-red-50"
                              onClick={() => openMovimentacao(produto, 'saida')}
                              disabled={semEstoque}
                            >
                              <ArrowUpCircle className="h-4 w-4" />
                            </Button>
                            <Button
                              size="sm"
                              variant="ghost"
                              onClick={() => openEditProduto(produto)}
                              title="Editar"
                            >
                              <Edit className="h-4 w-4" />
                            </Button>
                            <Button
                              size="sm"
                              variant="ghost"
                              className="text-blue-500 hover:text-blue-700"
                              onClick={() => duplicarProduto(produto)}
                              title="Duplicar produto"
                              data-testid={`duplicate-product-${produto.id}`}
                            >
                              <Copy className="h-4 w-4" />
                            </Button>
                            <Button
                              size="sm"
                              variant="ghost"
                              className="text-red-500 hover:text-red-700"
                              onClick={() => setDeleteId(produto.id)}
                              title="Excluir"
                            >
                              <Trash2 className="h-4 w-4" />
                            </Button>
                          </div>
                        </div>
                      </div>
                      
                      {/* Estoque por Local */}
                      {produto.estoques && produto.estoques.length > 0 && (
                        <div className="mt-3 pt-3 border-t flex items-center gap-4 flex-wrap">
                          <span className="text-xs text-gray-500 uppercase">Por Local:</span>
                          {produto.estoques.map((est, idx) => (
                            <Badge key={est.local_id || est.local_nome || idx} variant="outline" className="text-xs">
                              <Building2 className="h-3 w-3 mr-1" />
                              {est.local_nome}: {est.quantidade} {produto.unidade}
                            </Badge>
                          ))}
                        </div>
                      )}
                      
                      {/* Fornecedores */}
                      {produto.fornecedores && produto.fornecedores.length > 0 && (
                        <div className="mt-2 flex items-center gap-2 flex-wrap">
                          <span className="text-xs text-gray-500 uppercase">Fornecedores:</span>
                          {produto.fornecedores.map((forn, idx) => (
                            <Badge 
                              key={forn.fornecedor_id || forn.fornecedor_nome || idx} 
                              variant="outline" 
                              className={`text-xs ${forn.is_principal ? 'border-blue-300 bg-blue-50' : ''}`}
                            >
                              <ShoppingCart className="h-3 w-3 mr-1" />
                              {forn.fornecedor_nome}
                              {forn.preco > 0 && ` - ${formatCurrency(forn.preco)}`}
                            </Badge>
                          ))}
                        </div>
                      )}
                    </CardContent>
                  </Card>
                );
              })
            }
          </div>
          )}
        </TabsContent>

        <TabsContent value="locais" className="mt-4">
          <div className="mb-4">
            <h3 className="text-lg font-semibold flex items-center gap-2">
              <Warehouse className="h-5 w-5 text-blue-600" />
              Locais de Estoque ({locaisEstoque.length})
            </h3>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {locaisEstoque.map(local => (
              <Card key={local.id}>
                <CardHeader className="pb-2">
                  <CardTitle className="text-lg flex items-center gap-2">
                    <Warehouse className="h-5 w-5 text-blue-600" />
                    {local.nome}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-500">Tipo:</span>
                      <Badge variant="outline">{local.tipo === 'fabrica' ? 'Fábrica' : local.tipo === 'deposito' ? 'Depósito' : local.tipo}</Badge>
                    </div>
                    {local.endereco && (
                      <div className="flex justify-between">
                        <span className="text-gray-500">Endereço:</span>
                        <span className="text-right">{local.endereco}</span>
                      </div>
                    )}
                    {local.responsavel && (
                      <div className="flex justify-between">
                        <span className="text-gray-500">Responsável:</span>
                        <span>{local.responsavel}</span>
                      </div>
                    )}
                  </div>
                </CardContent>
              </Card>
            ))}
            
            {locaisEstoque.length === 0 && (
              <Card className="col-span-full">
                <CardContent className="p-8 text-center">
                  <Warehouse className="h-12 w-12 mx-auto text-gray-300 mb-3" />
                  <p className="text-gray-500">Nenhum local de estoque cadastrado</p>
                  <p className="text-sm text-gray-400 mt-1">Clique em &quot;Novo Local&quot; para adicionar ou cadastre uma fábrica</p>
                </CardContent>
              </Card>
            )}
          </div>
        </TabsContent>

        {/* Aba de Marcas */}
        <TabsContent value="marcas" className="mt-4">
          <div className="mb-4">
            <h3 className="text-lg font-semibold flex items-center gap-2">
              <Tag className="h-5 w-5 text-purple-600" />
              Marcas Cadastradas ({marcas.length})
            </h3>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {marcas.map(marca => (
              <Card key={marca.id}>
                <CardContent className="p-4">
                  {editingMarca?.id === marca.id ? (
                    <div className="space-y-3">
                      <Input
                        value={editingMarca.nome}
                        onChange={(e) => setEditingMarca({...editingMarca, nome: e.target.value})}
                        placeholder="Nome da marca"
                      />
                      <Input
                        value={editingMarca.descricao || ''}
                        onChange={(e) => setEditingMarca({...editingMarca, descricao: e.target.value})}
                        placeholder="Descrição"
                      />
                      <Input
                        value={editingMarca.pais_origem || ''}
                        onChange={(e) => setEditingMarca({...editingMarca, pais_origem: e.target.value})}
                        placeholder="País de origem"
                      />
                      <div className="flex gap-2">
                        <Button size="sm" onClick={() => updateMarca(editingMarca)}>
                          <Check className="h-4 w-4 mr-1" /> Salvar
                        </Button>
                        <Button size="sm" variant="outline" onClick={() => setEditingMarca(null)}>
                          <X className="h-4 w-4 mr-1" /> Cancelar
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <div className="space-y-2">
                      <div className="flex items-center justify-between">
                        <span className="font-medium text-lg">{marca.nome}</span>
                        <div className="flex gap-1">
                          <Button size="sm" variant="ghost" onClick={() => setEditingMarca({...marca})}>
                            <Edit className="h-4 w-4" />
                          </Button>
                          <Button 
                            size="sm" 
                            variant="ghost" 
                            className="text-red-500 hover:text-red-700"
                            onClick={() => setDeleteConfirm({ type: 'marca', id: marca.id, nome: marca.nome })}
                          >
                            <Trash2 className="h-4 w-4" />
                          </Button>
                        </div>
                      </div>
                      {marca.descricao && <p className="text-sm text-gray-500">{marca.descricao}</p>}
                      {marca.pais_origem && (
                        <Badge variant="outline" className="text-xs">
                          {marca.pais_origem}
                        </Badge>
                      )}
                    </div>
                  )}
                </CardContent>
              </Card>
            ))}
            
            {marcas.length === 0 && (
              <Card className="col-span-full">
                <CardContent className="p-8 text-center">
                  <Tag className="h-12 w-12 mx-auto text-gray-300 mb-3" />
                  <p className="text-gray-500">Nenhuma marca cadastrada</p>
                  <p className="text-sm text-gray-400 mt-1">Clique em &quot;Nova Marca&quot; para adicionar</p>
                </CardContent>
              </Card>
            )}
          </div>
        </TabsContent>

        {/* Aba de Categorias */}
        <TabsContent value="categorias" className="mt-4">
          <div className="mb-4">
            <h3 className="text-lg font-semibold flex items-center gap-2">
              <FolderTree className="h-5 w-5 text-green-600" />
              Categorias de Produtos ({categoriasProduto.length})
            </h3>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {categoriasProduto.map(categoria => (
              <Card key={categoria.id}>
                <CardContent className="p-4">
                  {editingCategoria?.id === categoria.id ? (
                    <div className="space-y-3">
                      <Input
                        value={editingCategoria.nome}
                        onChange={(e) => setEditingCategoria({...editingCategoria, nome: e.target.value})}
                        placeholder="Nome da categoria"
                      />
                      <Textarea
                        value={editingCategoria.descricao || ''}
                        onChange={(e) => setEditingCategoria({...editingCategoria, descricao: e.target.value})}
                        placeholder="Descrição"
                        rows={2}
                      />
                      <div className="flex gap-2">
                        <Button size="sm" onClick={() => updateCategoria(editingCategoria)}>
                          <Check className="h-4 w-4 mr-1" /> Salvar
                        </Button>
                        <Button size="sm" variant="outline" onClick={() => setEditingCategoria(null)}>
                          <X className="h-4 w-4 mr-1" /> Cancelar
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <div className="space-y-2">
                      <div className="flex items-center justify-between">
                        <span className="font-medium text-lg">{categoria.nome}</span>
                        <div className="flex gap-1">
                          <Button size="sm" variant="ghost" onClick={() => setEditingCategoria({...categoria})}>
                            <Edit className="h-4 w-4" />
                          </Button>
                          <Button 
                            size="sm" 
                            variant="ghost" 
                            className="text-red-500 hover:text-red-700"
                            onClick={() => setDeleteConfirm({ type: 'categoria', id: categoria.id, nome: categoria.nome })}
                          >
                            <Trash2 className="h-4 w-4" />
                          </Button>
                        </div>
                      </div>
                      {categoria.descricao && <p className="text-sm text-gray-500">{categoria.descricao}</p>}
                    </div>
                  )}
                </CardContent>
              </Card>
            ))}
            
            {categoriasProduto.length === 0 && (
              <Card className="col-span-full">
                <CardContent className="p-8 text-center">
                  <FolderTree className="h-12 w-12 mx-auto text-gray-300 mb-3" />
                  <p className="text-gray-500">Nenhuma categoria cadastrada</p>
                  <p className="text-sm text-gray-400 mt-1">Clique em &quot;Nova Categoria&quot; para adicionar</p>
                </CardContent>
              </Card>
            )}
          </div>
        </TabsContent>

        {/* Aba de Tipos de Produto */}
        <TabsContent value="tipos" className="mt-4">
          <div className="mb-4">
            <h3 className="text-lg font-semibold flex items-center gap-2">
              <Layers className="h-5 w-5 text-orange-600" />
              Tipos de Produto ({tiposProduto.length})
            </h3>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {tiposProduto.map(tipo => (
              <Card key={tipo.id}>
                <CardContent className="p-4">
                  {editingTipoItem?.id === tipo.id ? (
                    <div className="space-y-3">
                      <Input
                        value={editingTipoItem.nome}
                        onChange={(e) => setEditingTipoItem({...editingTipoItem, nome: e.target.value})}
                        placeholder="Nome do tipo"
                      />
                      <Textarea
                        value={editingTipoItem.descricao || ''}
                        onChange={(e) => setEditingTipoItem({...editingTipoItem, descricao: e.target.value})}
                        placeholder="Descrição"
                        rows={2}
                      />
                      <div className="flex gap-2">
                        <Button size="sm" onClick={() => updateTipoProduto(editingTipoItem)}>
                          <Check className="h-4 w-4 mr-1" /> Salvar
                        </Button>
                        <Button size="sm" variant="outline" onClick={() => setEditingTipoItem(null)}>
                          <X className="h-4 w-4 mr-1" /> Cancelar
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <div className="space-y-2">
                      <div className="flex items-center justify-between">
                        <span className="font-medium text-lg">{tipo.nome}</span>
                        <div className="flex gap-1">
                          <Button size="sm" variant="ghost" onClick={() => setEditingTipoItem({...tipo})}>
                            <Edit className="h-4 w-4" />
                          </Button>
                          <Button 
                            size="sm" 
                            variant="ghost" 
                            className="text-red-500 hover:text-red-700"
                            onClick={() => setDeleteConfirm({ type: 'tipo', id: tipo.id, nome: tipo.nome })}
                          >
                            <Trash2 className="h-4 w-4" />
                          </Button>
                        </div>
                      </div>
                      {tipo.descricao && <p className="text-sm text-gray-500">{tipo.descricao}</p>}
                    </div>
                  )}
                </CardContent>
              </Card>
            ))}
            
            {tiposProduto.length === 0 && (
              <Card className="col-span-full">
                <CardContent className="p-8 text-center">
                  <Layers className="h-12 w-12 mx-auto text-gray-300 mb-3" />
                  <p className="text-gray-500">Nenhum tipo de produto cadastrado</p>
                  <p className="text-sm text-gray-400 mt-1">Clique em &quot;Novo Tipo de Produto&quot; para adicionar</p>
                </CardContent>
              </Card>
            )}
          </div>
        </TabsContent>
      </Tabs>

      {/* Dialog de Confirmação de Exclusão */}
      <AlertDialog open={deleteConfirm.type !== null} onOpenChange={() => setDeleteConfirm({ type: null, id: null, nome: '' })}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Confirmar Exclusão</AlertDialogTitle>
            <AlertDialogDescription>
              Tem certeza que deseja excluir "{deleteConfirm.nome}"? Esta ação não pode ser desfeita.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction
              className="bg-red-600 hover:bg-red-700"
              onClick={() => {
                if (deleteConfirm.type === 'marca') deleteMarca(deleteConfirm.id);
                else if (deleteConfirm.type === 'categoria') deleteCategoria(deleteConfirm.id);
                else if (deleteConfirm.type === 'tipo') deleteTipoProduto(deleteConfirm.id);
              }}
            >
              Excluir
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Dialog Produto */}
      <Dialog open={showProdutoDialog} onOpenChange={setShowProdutoDialog}>
        <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Package className="h-5 w-5 text-blue-600" />
              {editingProduto ? 'Editar Produto' : 'Novo Produto'}
            </DialogTitle>
          </DialogHeader>
          
          <Tabs defaultValue="basico" className="w-full">
            <TabsList className="grid w-full grid-cols-7">
              <TabsTrigger value="basico">Básico</TabsTrigger>
              <TabsTrigger value="estoque">Estoque</TabsTrigger>
              <TabsTrigger value="fiscal">Fiscal</TabsTrigger>
              <TabsTrigger value="importacao" data-testid="tab-importacao">Importação</TabsTrigger>
              <TabsTrigger value="dimensoes">Dimensões</TabsTrigger>
              <TabsTrigger value="frete">Frete</TabsTrigger>
              <TabsTrigger value="fornecedores">Fornecedores</TabsTrigger>
            </TabsList>
            
            {/* ABA BÁSICO */}
            <TabsContent value="basico" className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                {/* Linha 1: SKU e Código de Barras */}
                <div>
                  <Label>Código (SKU)</Label>
                  <Input
                    value={produtoForm.sku}
                    onChange={(e) => setProdutoForm({...produtoForm, sku: e.target.value})}
                    placeholder="Auto-gerado se vazio"
                  />
                  <p className="text-xs text-gray-500 mt-1">Deixe vazio para gerar automaticamente</p>
                </div>
                
                <div>
                  <Label>Código de Barras</Label>
                  <Input
                    value={produtoForm.codigo_barras}
                    onChange={(e) => setProdutoForm({...produtoForm, codigo_barras: e.target.value})}
                    placeholder="EAN/GTIN"
                  />
                </div>
                
                {/* Linha 2: Nome e Modelo */}
                <div>
                  <Label>Nome do Produto *</Label>
                  <Input
                    value={produtoForm.nome}
                    onChange={(e) => setProdutoForm({...produtoForm, nome: e.target.value})}
                    placeholder="Ex: Motor Mercury 150HP 4T"
                    data-testid="produto-nome"
                  />
                </div>
                
                <div>
                  <Label>Modelo</Label>
                  <Input
                    value={produtoForm.modelo}
                    onChange={(e) => setProdutoForm({...produtoForm, modelo: e.target.value})}
                    placeholder="Ex: XYZ-2024"
                  />
                </div>
                
                <div className="col-span-2">
                  <Label>Descrição Resumida</Label>
                  <Input
                    value={produtoForm.descricao}
                    onChange={(e) => setProdutoForm({...produtoForm, descricao: e.target.value})}
                    placeholder="Descrição curta do produto"
                  />
                </div>
                
                <div>
                  <Label className="flex items-center gap-2">
                    Categoria
                    <Button 
                      type="button" 
                      variant="ghost" 
                      size="sm" 
                      className="h-6 px-2"
                      onClick={() => setShowCategoriaDialog(true)}
                    >
                      <Plus className="h-3 w-3 mr-1" />
                      Nova
                    </Button>
                  </Label>
                  <Select 
                    value={produtoForm.categoria || 'none'} 
                    onValueChange={(v) => setProdutoForm({...produtoForm, categoria: v === 'none' ? '' : v})}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Selecione..." />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="none">Selecione...</SelectItem>
                      {categoriasProduto.map(cat => (
                        <SelectItem key={cat.id} value={cat.nome}>{cat.nome}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                
                <div className="col-span-2">
                  <Label className="flex items-center gap-2 mb-2">
                    Tipos do Produto
                    <Button 
                      type="button" 
                      variant="ghost" 
                      size="sm" 
                      className="h-6 px-2"
                      onClick={() => setShowTipoDialog(true)}
                    >
                      <Plus className="h-3 w-3 mr-1" />
                      Novo
                    </Button>
                  </Label>
                  <div className="flex flex-wrap gap-3 p-3 border rounded-lg bg-gray-50">
                    {(tiposProduto.length > 0 ? tiposProduto : TIPOS_PRODUTO.map(t => ({id: t.value, value: t.value, nome: t.label}))).map(tipo => (
                      <label key={tipo.id || tipo.value} className="flex items-center gap-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={produtoForm.tipos?.includes(tipo.value)}
                          onChange={(e) => {
                            const tiposAtuais = produtoForm.tipos || [];
                            if (e.target.checked) {
                              setProdutoForm({...produtoForm, tipos: [...tiposAtuais, tipo.value]});
                            } else {
                              setProdutoForm({...produtoForm, tipos: tiposAtuais.filter(t => t !== tipo.value)});
                            }
                          }}
                          className="w-4 h-4 rounded border-gray-300"
                        />
                        <span className="text-sm">{tipo.nome || tipo.label}</span>
                      </label>
                    ))}
                  </div>
                  <p className="text-xs text-gray-500 mt-1">Selecione um ou mais tipos que se aplicam ao produto</p>
                </div>
                
                <div>
                  <Label className="flex items-center gap-2">
                    Marca
                    <Button 
                      type="button" 
                      variant="ghost" 
                      size="sm" 
                      className="h-6 px-2"
                      onClick={() => setShowMarcaDialog(true)}
                    >
                      <Plus className="h-3 w-3 mr-1" />
                      Nova
                    </Button>
                  </Label>
                  <Select 
                    value={produtoForm.marca_id || 'none'} 
                    onValueChange={(v) => handleMarcaChange(v === 'none' ? '' : v)}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Selecione a marca..." />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="none">Sem marca</SelectItem>
                      {marcas.map(m => (
                        <SelectItem key={m.id} value={m.id}>{m.nome}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                
                <div>
                  <Label>Procedência</Label>
                  <div className="flex items-center gap-6 mt-2 p-3 border rounded-lg bg-gray-50">
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="procedencia"
                        value="nacional"
                        checked={produtoForm.procedencia === 'nacional'}
                        onChange={(e) => setProdutoForm({...produtoForm, procedencia: e.target.value})}
                        className="w-4 h-4"
                        data-testid="produto-procedencia-nacional"
                      />
                      <span className="text-sm">Nacional</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="procedencia"
                        value="importado"
                        checked={produtoForm.procedencia === 'importado'}
                        onChange={(e) => setProdutoForm({...produtoForm, procedencia: e.target.value})}
                        className="w-4 h-4"
                        data-testid="produto-procedencia-importado"
                      />
                      <span className="text-sm">Importado</span>
                    </label>
                  </div>
                </div>
                
                <div>
                  <Label>Unidade de Medida</Label>
                  <Select 
                    value={produtoForm.unidade} 
                    onValueChange={(v) => setProdutoForm({...produtoForm, unidade: v})}
                  >
                    <SelectTrigger>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {UNIDADES.map(un => (
                        <SelectItem key={un.value} value={un.value}>{un.label}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                
                {/* Impacto no preço da embarcação */}
                <div className="col-span-2 p-3 border rounded-lg bg-blue-50">
                  <div className="flex items-center gap-4">
                    <div className="flex items-center gap-2">
                      <input 
                        type="checkbox" 
                        id="impacta_preco"
                        checked={produtoForm.impacta_preco_embarcacao}
                        onChange={(e) => setProdutoForm({...produtoForm, impacta_preco_embarcacao: e.target.checked})}
                        className="w-4 h-4"
                      />
                      <Label htmlFor="impacta_preco" className="cursor-pointer">Impacta preço da embarcação</Label>
                    </div>
                    
                    {produtoForm.impacta_preco_embarcacao && (
                      <div className="flex-1">
                        <Select 
                          value={produtoForm.tipo_impacto} 
                          onValueChange={(v) => setProdutoForm({...produtoForm, tipo_impacto: v})}
                        >
                          <SelectTrigger className="w-48">
                            <SelectValue />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="padrao">Padrão (incluso)</SelectItem>
                            <SelectItem value="opcional">Opcional (adicional)</SelectItem>
                            <SelectItem value="upgrade">Upgrade (substituição)</SelectItem>
                          </SelectContent>
                        </Select>
                      </div>
                    )}
                  </div>
                </div>
                
                <div>
                  <Label>Garantia (meses)</Label>
                  <Input
                    type="number"
                    value={produtoForm.garantia_meses}
                    onChange={(e) => setProdutoForm({...produtoForm, garantia_meses: parseInt(e.target.value) || 0})}
                    placeholder="0"
                  />
                </div>
                
                <div>
                  <Label>Localização Padrão</Label>
                  <Input
                    value={produtoForm.localizacao_fisica_padrao}
                    onChange={(e) => setProdutoForm({...produtoForm, localizacao_fisica_padrao: e.target.value})}
                    placeholder="Ex: Prateleira A-12"
                  />
                </div>
                
                <div className="col-span-2">
                  <Label>Descrição Técnica Completa</Label>
                  <Textarea
                    value={produtoForm.descricao_completa}
                    onChange={(e) => setProdutoForm({...produtoForm, descricao_completa: e.target.value})}
                    rows={3}
                    placeholder="Especificações técnicas detalhadas do produto..."
                  />
                </div>
                
                <div className="col-span-2">
                  <Label>Observações</Label>
                  <Textarea
                    value={produtoForm.observacoes}
                    onChange={(e) => setProdutoForm({...produtoForm, observacoes: e.target.value})}
                    rows={2}
                    placeholder="Notas adicionais..."
                  />
                </div>
                
                {/* Anexos */}
                <div className="col-span-2">
                  <AnexosErrorBoundary>
                    <AnexosManager
                      anexos={produtoForm.anexos || []}
                      onChange={(novos) => setProdutoForm({...produtoForm, anexos: novos})}
                      maxFiles={20}
                      maxSizeMB={50}
                      label="Anexos do Produto"
                      modulo="produtos"
                      entidadeId={editingProduto?.id || 'novo'}
                      categoria="documentacao"
                    />
                  </AnexosErrorBoundary>
                </div>
              </div>
            </TabsContent>
            
            {/* ABA ESTOQUE */}
            <TabsContent value="estoque" className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>Estoque Mínimo</Label>
                  <Input
                    type="number"
                    value={produtoForm.estoque_minimo}
                    onChange={(e) => setProdutoForm({...produtoForm, estoque_minimo: parseFloat(e.target.value) || 0})}
                  />
                  <p className="text-xs text-gray-500 mt-1">Alerta quando atingir este nível</p>
                </div>
                
                <div>
                  <Label>Estoque Máximo</Label>
                  <Input
                    type="number"
                    value={produtoForm.estoque_maximo}
                    onChange={(e) => setProdutoForm({...produtoForm, estoque_maximo: e.target.value})}
                    placeholder="Opcional"
                  />
                </div>
                
                <div>
                  <Label>Alerta de compra com estoque em</Label>
                  <Input
                    type="number"
                    value={produtoForm.ponto_pedido}
                    onChange={(e) => setProdutoForm({...produtoForm, ponto_pedido: parseFloat(e.target.value) || 0})}
                  />
                  <p className="text-xs text-gray-500 mt-1">Alerta quando atingir este nível</p>
                </div>
              </div>
              
              {/* Preços */}
              <div className="border-t pt-4 mt-4">
                <div className="flex items-center justify-between mb-3">
                  <h4 className="font-medium">Preços e Margem</h4>
                  <div className="w-56">
                    <MoedaSelect
                      value={produtoForm.moeda || 'BRL'}
                      onChange={(v) => setProdutoForm(prev => ({ ...prev, moeda: v }))}
                      className="h-9"
                      testId="produto-moeda-select"
                    />
                  </div>
                </div>
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <Label>Preço de Custo ({getCurrencyMeta(produtoForm.moeda).symbol})</Label>
                    <Input
                      type="number"
                      step="0.01"
                      value={produtoForm.preco_custo}
                      onChange={(e) => handlePrecoCustoChange(e.target.value)}
                      data-testid="produto-preco-custo"
                    />
                  </div>
                  
                  <div>
                    <Label>Margem (%)</Label>
                    <Input
                      type="number"
                      step="0.01"
                      value={produtoForm.margem_percentual}
                      onChange={(e) => handleMargemChange(e.target.value)}
                      placeholder="0"
                    />
                    <p className="text-xs text-gray-500 mt-1">Calcula preço automaticamente</p>
                  </div>
                  
                  <div>
                    <Label>Preço de Venda ({getCurrencyMeta(produtoForm.moeda).symbol})</Label>
                    <Input
                      type="number"
                      step="0.01"
                      value={produtoForm.preco_venda}
                      onChange={(e) => handlePrecoVendaChange(e.target.value)}
                      placeholder="0,00"
                      data-testid="produto-preco-venda"
                    />
                    <p className="text-xs text-gray-500 mt-1">Ou digite manualmente</p>
                  </div>
                </div>
              </div>
            </TabsContent>
            
            {/* ABA FISCAL */}
            <TabsContent value="fiscal" className="space-y-4">
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <Label>NCM</Label>
                  <Input
                    value={produtoForm.ncm}
                    onChange={(e) => setProdutoForm({...produtoForm, ncm: e.target.value})}
                    placeholder="00000000"
                    maxLength={8}
                  />
                </div>
                
                <div>
                  <Label>CEST</Label>
                  <Input
                    value={produtoForm.cest}
                    onChange={(e) => setProdutoForm({...produtoForm, cest: e.target.value})}
                    placeholder="0000000"
                    maxLength={7}
                  />
                </div>
                
                <div>
                  <Label>Origem</Label>
                  <Select 
                    value={produtoForm.origem} 
                    onValueChange={(v) => setProdutoForm({...produtoForm, origem: v})}
                  >
                    <SelectTrigger>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="0">0 - Nacional</SelectItem>
                      <SelectItem value="1">1 - Importação direta</SelectItem>
                      <SelectItem value="2">2 - Adquirido internamente</SelectItem>
                      <SelectItem value="3">3 - Nacional c/ mais de 40% importado</SelectItem>
                      <SelectItem value="5">5 - Nacional c/ até 40% importado</SelectItem>
                      <SelectItem value="8">8 - Nacional - Importação indireta</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                
                <div>
                  <Label>CFOP Entrada</Label>
                  <Input
                    value={produtoForm.cfop_entrada}
                    onChange={(e) => setProdutoForm({...produtoForm, cfop_entrada: e.target.value})}
                    placeholder="0000"
                    maxLength={4}
                  />
                </div>
                
                <div>
                  <Label>CFOP Saída</Label>
                  <Input
                    value={produtoForm.cfop_saida}
                    onChange={(e) => setProdutoForm({...produtoForm, cfop_saida: e.target.value})}
                    placeholder="0000"
                    maxLength={4}
                  />
                </div>
                
                <div>
                  <Label>CST ICMS</Label>
                  <Input
                    value={produtoForm.cst_icms}
                    onChange={(e) => setProdutoForm({...produtoForm, cst_icms: e.target.value})}
                    placeholder="00"
                    maxLength={3}
                  />
                </div>
                
                <div>
                  <Label>Alíq. ICMS (%)</Label>
                  <Input
                    type="number"
                    step="0.01"
                    value={produtoForm.aliq_icms}
                    onChange={(e) => setProdutoForm({...produtoForm, aliq_icms: parseFloat(e.target.value) || 0})}
                  />
                </div>
                
                <div>
                  <Label>Alíq. IPI (%)</Label>
                  <Input
                    type="number"
                    step="0.01"
                    value={produtoForm.aliq_ipi}
                    onChange={(e) => setProdutoForm({...produtoForm, aliq_ipi: parseFloat(e.target.value) || 0})}
                  />
                </div>
                
                <div>
                  <Label>Alíq. PIS (%)</Label>
                  <Input
                    type="number"
                    step="0.01"
                    value={produtoForm.aliq_pis}
                    onChange={(e) => setProdutoForm({...produtoForm, aliq_pis: parseFloat(e.target.value) || 0})}
                  />
                </div>
                
                <div>
                  <Label>Alíq. COFINS (%)</Label>
                  <Input
                    type="number"
                    step="0.01"
                    value={produtoForm.aliq_cofins}
                    onChange={(e) => setProdutoForm({...produtoForm, aliq_cofins: parseFloat(e.target.value) || 0})}
                  />
                </div>
              </div>
            </TabsContent>
            
            {/* ABA IMPORTAÇÃO */}
            <TabsContent value="importacao" className="space-y-4" data-testid="tab-content-importacao">
              <div className="flex items-start gap-2 rounded-lg bg-indigo-50 border border-indigo-100 p-3 text-xs text-indigo-800">
                <Globe className="h-4 w-4 mt-0.5 shrink-0" />
                <span>Dados usados quando este produto é importado. Alimentam as cotações/pedidos internacionais (HS Code, licenças, CBM para frete).</span>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>HS Code (classificação internacional)</Label>
                  <Input
                    value={produtoForm.hs_code}
                    onChange={(e) => setProdutoForm({ ...produtoForm, hs_code: e.target.value })}
                    placeholder="Ex: 8407.21"
                    data-testid="produto-hs-code"
                  />
                </div>
                <div>
                  <Label>País de Origem</Label>
                  <Select
                    value={produtoForm.pais_origem || 'none'}
                    onValueChange={(v) => setProdutoForm({ ...produtoForm, pais_origem: v === 'none' ? '' : v })}
                  >
                    <SelectTrigger data-testid="produto-pais-origem">
                      <SelectValue placeholder="Selecione o país" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="none">— Não informado —</SelectItem>
                      {PAISES.filter(p => p.code !== 'OTHER').map(p => (
                        <SelectItem key={p.code} value={p.code}>{p.nome}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label>Lead Time de fabricação (dias)</Label>
                  <Input
                    type="number"
                    min="0"
                    value={produtoForm.lead_time_fabricacao_dias}
                    onChange={(e) => setProdutoForm({ ...produtoForm, lead_time_fabricacao_dias: e.target.value === '' ? '' : parseInt(e.target.value) })}
                    placeholder="Ex: 60"
                    data-testid="produto-lead-time-fab"
                  />
                </div>
                <div>
                  <Label>Quantidade de volumes</Label>
                  <Input
                    type="number"
                    min="0"
                    value={produtoForm.quantidade_volumes}
                    onChange={(e) => setProdutoForm({ ...produtoForm, quantidade_volumes: e.target.value === '' ? '' : parseInt(e.target.value) })}
                    placeholder="Ex: 1"
                    data-testid="produto-qtd-volumes"
                  />
                </div>
              </div>

              {/* CBM (calculado das dimensões × volumes, com override manual) */}
              <div className="rounded-lg border border-slate-200 p-3 bg-slate-50">
                <div className="flex items-center justify-between flex-wrap gap-2">
                  <div>
                    <Label className="text-sm">Volume total (CBM — m³)</Label>
                    <p className="text-xs text-slate-500">
                      Calculado: {(() => {
                        const d = produtoForm.dimensoes || {};
                        const un = ((d.comprimento_cm || 0) * (d.largura_cm || 0) * (d.altura_cm || 0)) / 1000000;
                        const qtd = produtoForm.quantidade_volumes || 1;
                        return (un * qtd).toFixed(4);
                      })()} m³ (dimensões × volumes)
                    </p>
                  </div>
                  <div className="flex items-end gap-2">
                    <Input
                      type="number"
                      step="0.0001"
                      min="0"
                      value={produtoForm.volume_cbm}
                      onChange={(e) => setProdutoForm({ ...produtoForm, volume_cbm: e.target.value === '' ? '' : parseFloat(e.target.value) })}
                      placeholder="CBM manual"
                      className="w-36"
                      data-testid="produto-cbm"
                    />
                    <Button
                      type="button"
                      variant="outline"
                      size="sm"
                      onClick={() => {
                        const d = produtoForm.dimensoes || {};
                        const un = ((d.comprimento_cm || 0) * (d.largura_cm || 0) * (d.altura_cm || 0)) / 1000000;
                        const qtd = produtoForm.quantidade_volumes || 1;
                        setProdutoForm({ ...produtoForm, volume_cbm: parseFloat((un * qtd).toFixed(4)) });
                      }}
                      data-testid="produto-cbm-usar-calculado"
                    >
                      Usar calculado
                    </Button>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                <label className="flex items-center justify-between rounded-lg border border-slate-200 p-3 cursor-pointer" data-testid="produto-necessita-li">
                  <span className="text-sm">Necessita LI (Licença de Importação)?</span>
                  <Switch
                    checked={!!produtoForm.necessita_li}
                    onCheckedChange={(v) => setProdutoForm({ ...produtoForm, necessita_li: v })}
                  />
                </label>
                <label className="flex items-center justify-between rounded-lg border border-slate-200 p-3 cursor-pointer" data-testid="produto-licenca-exercito">
                  <span className="text-sm">Necessita licença do Exército?</span>
                  <Switch
                    checked={!!produtoForm.necessita_licenca_exercito}
                    onCheckedChange={(v) => setProdutoForm({ ...produtoForm, necessita_licenca_exercito: v })}
                  />
                </label>
                <label className="flex items-center justify-between rounded-lg border border-slate-200 p-3 cursor-pointer" data-testid="produto-sob-encomenda">
                  <span className="text-sm">Fabricado sob encomenda?</span>
                  <Switch
                    checked={!!produtoForm.fabricado_sob_encomenda}
                    onCheckedChange={(v) => setProdutoForm({ ...produtoForm, fabricado_sob_encomenda: v })}
                  />
                </label>
              </div>
            </TabsContent>
            
            {/* ABA DIMENSÕES */}
            <TabsContent value="dimensoes" className="space-y-4">
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <Label>Comprimento (cm)</Label>
                  <Input
                    type="number"
                    step="0.1"
                    value={produtoForm.dimensoes?.comprimento_cm || 0}
                    onChange={(e) => setProdutoForm({
                      ...produtoForm, 
                      dimensoes: {...(produtoForm.dimensoes || {}), comprimento_cm: parseFloat(e.target.value) || 0}
                    })}
                  />
                </div>
                
                <div>
                  <Label>Largura (cm)</Label>
                  <Input
                    type="number"
                    step="0.1"
                    value={produtoForm.dimensoes?.largura_cm || 0}
                    onChange={(e) => setProdutoForm({
                      ...produtoForm, 
                      dimensoes: {...(produtoForm.dimensoes || {}), largura_cm: parseFloat(e.target.value) || 0}
                    })}
                  />
                </div>
                
                <div>
                  <Label>Altura (cm)</Label>
                  <Input
                    type="number"
                    step="0.1"
                    value={produtoForm.dimensoes?.altura_cm || 0}
                    onChange={(e) => setProdutoForm({
                      ...produtoForm, 
                      dimensoes: {...(produtoForm.dimensoes || {}), altura_cm: parseFloat(e.target.value) || 0}
                    })}
                  />
                </div>
                
                <div>
                  <Label>Volume (m³)</Label>
                  <Input
                    type="number"
                    step="0.001"
                    value={produtoForm.volume_m3}
                    onChange={(e) => setProdutoForm({...produtoForm, volume_m3: parseFloat(e.target.value) || 0})}
                  />
                </div>
                
                <div>
                  <Label>Peso Bruto (kg)</Label>
                  <Input
                    type="number"
                    step="0.01"
                    value={produtoForm.peso_bruto}
                    onChange={(e) => setProdutoForm({...produtoForm, peso_bruto: parseFloat(e.target.value) || 0})}
                  />
                </div>
                
                <div>
                  <Label>Peso Líquido (kg)</Label>
                  <Input
                    type="number"
                    step="0.01"
                    value={produtoForm.peso_liquido}
                    onChange={(e) => setProdutoForm({...produtoForm, peso_liquido: parseFloat(e.target.value) || 0})}
                  />
                </div>
              </div>
            </TabsContent>
            
            {/* ABA FRETE */}
            <TabsContent value="frete" className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>Tipo de Embalagem</Label>
                  <Select 
                    value={produtoForm.tipo_embalagem || 'none'} 
                    onValueChange={(v) => setProdutoForm({...produtoForm, tipo_embalagem: v === 'none' ? '' : v})}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Selecione..." />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="none">Selecione...</SelectItem>
                      <SelectItem value="caixa">Caixa</SelectItem>
                      <SelectItem value="pallet">Pallet</SelectItem>
                      <SelectItem value="envelope">Envelope</SelectItem>
                      <SelectItem value="sacola">Sacola</SelectItem>
                      <SelectItem value="tambor">Tambor/Barril</SelectItem>
                      <SelectItem value="granel">Granel</SelectItem>
                      <SelectItem value="container">Container</SelectItem>
                      <SelectItem value="outro">Outro</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                
                <div>
                  <Label>Classe de Transporte</Label>
                  <Select 
                    value={produtoForm.classe_transporte} 
                    onValueChange={(v) => setProdutoForm({...produtoForm, classe_transporte: v})}
                  >
                    <SelectTrigger>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="normal">Normal</SelectItem>
                      <SelectItem value="fragil">Frágil</SelectItem>
                      <SelectItem value="perigoso">Perigoso</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
              </div>
              
              <div className="p-4 bg-gray-50 rounded-lg">
                <h4 className="font-medium mb-2 flex items-center gap-2">
                  <Truck className="h-4 w-4" />
                  Informações de Frete
                </h4>
                <p className="text-sm text-gray-600">
                  Essas informações são utilizadas para cálculo de frete e orientação no transporte.
                </p>
                {produtoForm.classe_transporte === 'perigoso' && (
                  <div className="mt-3 p-2 bg-red-50 border border-red-200 rounded text-sm text-red-700">
                    ⚠️ Produto classificado como <strong>PERIGOSO</strong>. Certifique-se de seguir todas as normas de transporte aplicáveis.
                  </div>
                )}
                {produtoForm.classe_transporte === 'fragil' && (
                  <div className="mt-3 p-2 bg-yellow-50 border border-yellow-200 rounded text-sm text-yellow-700">
                    ⚠️ Produto classificado como <strong>FRÁGIL</strong>. Embalagem especial recomendada.
                  </div>
                )}
              </div>
            </TabsContent>
            
            {/* ABA FORNECEDORES */}
            <TabsContent value="fornecedores" className="space-y-4">
              <div className="flex items-center justify-between mb-3">
                <Label className="text-base font-semibold flex items-center gap-2">
                  <ShoppingCart className="h-4 w-4" />
                  Fornecedores Vinculados ({produtoForm.fornecedores.length})
                </Label>
                <Button 
                  type="button" 
                  size="sm" 
                  variant="outline"
                  onClick={() => setShowAddFornecedor(true)}
                >
                  <Plus className="h-4 w-4 mr-1" />
                  Adicionar Fornecedor
                </Button>
              </div>
              
              {produtoForm.fornecedores.length === 0 ? (
                <div className="text-center py-6 border-2 border-dashed rounded-lg">
                  <ShoppingCart className="h-10 w-10 mx-auto text-gray-300 mb-2" />
                  <p className="text-sm text-gray-500">Nenhum fornecedor vinculado</p>
                  <p className="text-xs text-gray-400">Clique em &quot;Adicionar Fornecedor&quot; para vincular</p>
                </div>
              ) : (
                <div className="space-y-2">
                  {produtoForm.fornecedores.map((forn, idx) => (
                    <div key={forn.fornecedor_id || idx} className={`p-3 border rounded-lg ${forn.is_principal ? 'border-blue-300 bg-blue-50' : ''}`}>
                      <div className="flex items-center justify-between">
                        <div className="flex-1">
                          <div className="flex items-center gap-2">
                            <span className="font-medium">{forn.fornecedor_nome}</span>
                            {forn.is_principal && (
                              <Badge className="text-xs bg-blue-100 text-blue-700">Principal</Badge>
                            )}
                          </div>
                          <div className="flex items-center gap-4 text-sm text-gray-500 mt-1">
                            <span>Preço: {formatCurrency(forn.preco)}</span>
                            {forn.prazo_entrega_dias > 0 && (
                              <span>Prazo: {forn.prazo_entrega_dias} dias</span>
                            )}
                            {forn.codigo_fornecedor && (
                              <span>Cód: {forn.codigo_fornecedor}</span>
                            )}
                          </div>
                        </div>
                        <div className="flex items-center gap-2">
                          {!forn.is_principal && (
                            <Button 
                              type="button"
                              size="sm" 
                              variant="ghost"
                              onClick={() => toggleFornecedorPrincipal(forn.fornecedor_id)}
                              title="Definir como principal"
                            >
                              <CheckCircle2 className="h-4 w-4 text-gray-400" />
                            </Button>
                          )}
                          <Button 
                            type="button"
                            size="sm" 
                            variant="ghost"
                            className="text-red-500 hover:text-red-700"
                            onClick={() => removeFornecedorDoProduto(forn.fornecedor_id)}
                          >
                            <Trash2 className="h-4 w-4" />
                          </Button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              
              {/* Mini-form para adicionar fornecedor */}
              {showAddFornecedor && (
                <div className="mt-3 p-4 border rounded-lg bg-gray-50">
                  <div className="grid grid-cols-2 gap-3">
                    <div className="col-span-2">
                      <Label className="text-sm">Fornecedor *</Label>
                      <Select 
                        value={novoFornecedor.fornecedor_id} 
                        onValueChange={(v) => setNovoFornecedor({...novoFornecedor, fornecedor_id: v})}
                      >
                        <SelectTrigger>
                          <SelectValue placeholder="Selecione um fornecedor..." />
                        </SelectTrigger>
                        <SelectContent>
                          {fornecedores.map(f => (
                            <SelectItem key={f.id} value={f.id}>
                              {f.nome_fantasia || f.razao_social}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </div>
                    
                    <div>
                      <Label className="text-sm">Preço (R$)</Label>
                      <Input
                        type="number"
                        step="0.01"
                        value={novoFornecedor.preco}
                        onChange={(e) => setNovoFornecedor({...novoFornecedor, preco: e.target.value})}
                        placeholder="0,00"
                      />
                    </div>
                    
                    <div>
                      <Label className="text-sm">Prazo Entrega (dias)</Label>
                      <Input
                        type="number"
                        value={novoFornecedor.prazo_entrega_dias}
                        onChange={(e) => setNovoFornecedor({...novoFornecedor, prazo_entrega_dias: e.target.value})}
                        placeholder="0"
                      />
                    </div>
                    
                    <div>
                      <Label className="text-sm">Código no Fornecedor</Label>
                      <Input
                        value={novoFornecedor.codigo_fornecedor}
                        onChange={(e) => setNovoFornecedor({...novoFornecedor, codigo_fornecedor: e.target.value})}
                        placeholder="SKU do fornecedor"
                      />
                    </div>
                    
                    <div>
                      <Label className="text-sm">Qtd. Mínima</Label>
                      <Input
                        type="number"
                        value={novoFornecedor.quantidade_minima}
                        onChange={(e) => setNovoFornecedor({...novoFornecedor, quantidade_minima: e.target.value})}
                        placeholder="1"
                      />
                    </div>
                  </div>
                  
                  <div className="flex justify-end gap-2 mt-3">
                    <Button 
                      type="button"
                      size="sm" 
                      variant="outline"
                      onClick={() => setShowAddFornecedor(false)}
                    >
                      Cancelar
                    </Button>
                    <Button 
                      type="button"
                      size="sm"
                      onClick={addFornecedorAoProduto}
                    >
                      Vincular Fornecedor
                    </Button>
                  </div>
                </div>
              )}
            </TabsContent>
          </Tabs>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowProdutoDialog(false)}>
              Cancelar
            </Button>
            <Button onClick={saveProduto} disabled={savingProduto} data-testid="salvar-produto-btn">
              {savingProduto ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
              {editingProduto ? 'Salvar Alterações' : 'Cadastrar Produto'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      
      {/* Dialog Nova Marca */}
      <Dialog open={showMarcaDialog} onOpenChange={setShowMarcaDialog}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Nova Marca</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label>Nome da Marca *</Label>
              <Input
                value={novaMarca.nome}
                onChange={(e) => setNovaMarca({...novaMarca, nome: e.target.value})}
                placeholder="Ex: Mercury Marine"
              />
            </div>
            <div>
              <Label>Descrição</Label>
              <Input
                value={novaMarca.descricao}
                onChange={(e) => setNovaMarca({...novaMarca, descricao: e.target.value})}
                placeholder="Breve descrição da marca"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>País de Origem</Label>
                <Input
                  value={novaMarca.pais_origem}
                  onChange={(e) => setNovaMarca({...novaMarca, pais_origem: e.target.value})}
                  placeholder="Ex: EUA"
                />
              </div>
              <div>
                <Label>Site</Label>
                <Input
                  value={novaMarca.site}
                  onChange={(e) => setNovaMarca({...novaMarca, site: e.target.value})}
                  placeholder="https://..."
                />
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowMarcaDialog(false)}>Cancelar</Button>
            <Button onClick={saveMarca} disabled={savingMarca}>
              {savingMarca ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
              Criar Marca
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog Nova Categoria */}
      <Dialog open={showCategoriaDialog} onOpenChange={setShowCategoriaDialog}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Nova Categoria de Produto</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label>Nome da Categoria *</Label>
              <Input
                value={novaCategoria.nome}
                onChange={(e) => setNovaCategoria({...novaCategoria, nome: e.target.value})}
                placeholder="Ex: Elétrico"
              />
            </div>
            <div>
              <Label>Descrição</Label>
              <Input
                value={novaCategoria.descricao}
                onChange={(e) => setNovaCategoria({...novaCategoria, descricao: e.target.value})}
                placeholder="Breve descrição da categoria"
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowCategoriaDialog(false)}>Cancelar</Button>
            <Button onClick={saveCategoria} disabled={savingCategoria}>
              {savingCategoria ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
              Criar Categoria
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog Novo Tipo */}
      <Dialog open={showTipoDialog} onOpenChange={setShowTipoDialog}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Novo Tipo de Produto</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label>Nome do Tipo *</Label>
              <Input
                value={novoTipo.nome}
                onChange={(e) => setNovoTipo({...novoTipo, nome: e.target.value})}
                placeholder="Ex: Consumível"
              />
            </div>
            <div>
              <Label>Descrição</Label>
              <Input
                value={novoTipo.descricao}
                onChange={(e) => setNovoTipo({...novoTipo, descricao: e.target.value})}
                placeholder="Breve descrição do tipo"
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowTipoDialog(false)}>Cancelar</Button>
            <Button onClick={saveTipo} disabled={savingTipo}>
              {savingTipo ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
              Criar Tipo
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog Novo Local de Estoque */}
      <Dialog open={showLocalDialog} onOpenChange={setShowLocalDialog}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Novo Local de Estoque</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label>Nome do Local *</Label>
              <Input
                value={novoLocal.nome}
                onChange={(e) => setNovoLocal({...novoLocal, nome: e.target.value})}
                placeholder="Ex: Depósito Central"
              />
            </div>
            <div>
              <Label>Tipo</Label>
              <Select 
                value={novoLocal.tipo} 
                onValueChange={(v) => setNovoLocal({...novoLocal, tipo: v})}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="deposito">Depósito</SelectItem>
                  <SelectItem value="fabrica">Fábrica</SelectItem>
                  <SelectItem value="terceiros">Terceiros</SelectItem>
                  <SelectItem value="consignado">Consignado</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label>Endereço</Label>
              <Input
                value={novoLocal.endereco}
                onChange={(e) => setNovoLocal({...novoLocal, endereco: e.target.value})}
                placeholder="Endereço do local"
              />
            </div>
            <div>
              <Label>Responsável</Label>
              <Input
                value={novoLocal.responsavel}
                onChange={(e) => setNovoLocal({...novoLocal, responsavel: e.target.value})}
                placeholder="Nome do responsável"
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowLocalDialog(false)}>Cancelar</Button>
            <Button onClick={saveLocal} disabled={savingLocal}>
              {savingLocal ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
              Criar Local
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog Movimentação */}
      <Dialog open={showMovDialog} onOpenChange={setShowMovDialog}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              {movForm.tipo === 'entrada' ? (
                <ArrowDownCircle className="h-5 w-5 text-green-600" />
              ) : (
                <ArrowUpCircle className="h-5 w-5 text-red-600" />
              )}
              {movForm.tipo === 'entrada' ? 'Entrada de Estoque' : 'Saída de Estoque'}
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4">
            <div>
              <Label>Local de Estoque *</Label>
              <Select 
                value={movForm.local_id} 
                onValueChange={(v) => setMovForm({...movForm, local_id: v})}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Selecione o local..." />
                </SelectTrigger>
                <SelectContent>
                  {locaisEstoque.map(local => (
                    <SelectItem key={local.id} value={local.id}>{local.nome}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            
            <div>
              <Label>Quantidade *</Label>
              <Input
                type="number"
                step="0.01"
                value={movForm.quantidade}
                onChange={(e) => setMovForm({...movForm, quantidade: e.target.value})}
                placeholder="0"
              />
            </div>
            
            {movForm.tipo === 'entrada' && (
              <div>
                <Label>Custo Unitário (R$)</Label>
                <Input
                  type="number"
                  step="0.01"
                  value={movForm.custo_unitario}
                  onChange={(e) => setMovForm({...movForm, custo_unitario: e.target.value})}
                  placeholder="0,00"
                />
              </div>
            )}
            
            <div>
              <Label>Motivo</Label>
              <Select 
                value={movForm.motivo} 
                onValueChange={(v) => setMovForm({...movForm, motivo: v})}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {movForm.tipo === 'entrada' ? (
                    <>
                      <SelectItem value="compra">Compra</SelectItem>
                      <SelectItem value="devolucao">Devolução</SelectItem>
                      <SelectItem value="ajuste_inventario">Ajuste de Inventário</SelectItem>
                    </>
                  ) : (
                    <>
                      <SelectItem value="consumo_projeto">Consumo em Projeto</SelectItem>
                      <SelectItem value="perda">Perda/Avaria</SelectItem>
                      <SelectItem value="ajuste_inventario">Ajuste de Inventário</SelectItem>
                    </>
                  )}
                </SelectContent>
              </Select>
            </div>
            
            <div>
              <Label>Documento de Referência</Label>
              <Input
                value={movForm.documento_ref}
                onChange={(e) => setMovForm({...movForm, documento_ref: e.target.value})}
                placeholder="NF, Pedido, etc."
              />
            </div>
            
            <div>
              <Label>Observação</Label>
              <Textarea
                value={movForm.observacao}
                onChange={(e) => setMovForm({...movForm, observacao: e.target.value})}
                rows={2}
              />
            </div>
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowMovDialog(false)}>
              Cancelar
            </Button>
            <Button 
              onClick={saveMovimentacao} 
              disabled={savingMov}
              className={movForm.tipo === 'entrada' ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700'}
            >
              {savingMov ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
              Registrar {movForm.tipo === 'entrada' ? 'Entrada' : 'Saída'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog Confirmação Delete */}
      <AlertDialog open={!!deleteId} onOpenChange={() => setDeleteId(null)}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Desativar Produto?</AlertDialogTitle>
            <AlertDialogDescription>
              O produto será desativado e não aparecerá mais nas listagens. 
              Esta ação pode ser revertida posteriormente.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction onClick={deleteProduto} className="bg-red-600 hover:bg-red-700">
              Desativar
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};

export default Produtos;
